import React from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import { P2, P4, H4 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { ReactComponent as TrustpilotIcon } from './assets/TrustpilotIcon.svg';
import { ReactComponent as TrustpilotRating } from './assets/TrustpilotRating.svg';
import { Card } from './styles';

interface TrustpilotReviewProps {
  heading?: React.ReactNode;
  text: React.ReactNode;
  author: string;
  title: string;
}

const TrustpilotReview: React.FC<TrustpilotReviewProps> = ({
  heading,
  text,
  author,
  title,
}) => {
  return (
    <FlexColumn
      alignItems="center"
      gap="16px"
      height="100%"
      justifyContent="center"
      width="100%"
    >
      <Card>
        {heading && <H4 color={themeStyle.inkBase}>{heading}</H4>}
        <P2 color={themeStyle.inkBase}>{text}</P2>
        <P4 color={themeStyle.inkBase}>
          {author}, <b>{title}</b>
        </P4>
      </Card>
      <FlexColumn alignItems="center" gap="8px">
        <P4 color={themeStyle.inkLight}>Rated 4.8 | 400+ Reviews</P4>
        <TrustpilotRating />
        <TrustpilotIcon />
      </FlexColumn>
    </FlexColumn>
  );
};

export default React.memo(TrustpilotReview);
